<template>
  <div>
    <p class="tw:text-2xl tw:font-bold tw:mb-1">{{ $t('ri_nba_header') }}</p>
    <p class="tw:text-base tw:font-normal tw:mb-6">{{ $t('ri_nba_subtext') }}</p>

    <div class="tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:gap-4">
      <div class="tw:border tw:border-blue-700 tw:bg-[#F5FBFF] tw:rounded-lg tw:px-5 tw:py-4 tw:flex tw:flex-col">
        <div class="tw:flex tw:flex-col tw:items-start tw:mb-1">
          <img :src="CoinsIcon" alt="Coins Icon" class="tw:w-6 tw:h-10" />
          <p class="tw:text-xl tw:font-bold tw:text-gray-800">{{ $t('ri_nba_visitors_profile') }}</p>
        </div>
        <p class="tw:text-base tw:font-normal tw:text-gray-800 tw:mb-4 tw:flex-1">
          {{ $t('ri_nba_vp_subtext') }}
        </p>
        <div class="tw:border-t tw:border-gray-300 tw:pt-3">
          <router-link
            :to="{ name: 'visitors-profile' }"
            class="tw:text-blue-700 tw:text-base tw:font-bold tw:hover:underline"
          >
            {{ $t('ri_nba_vp_cta') }}
          </router-link>
        </div>
      </div>

      <div class="tw:border tw:border-blue-700 tw:bg-[#F5FBFF] tw:rounded-lg tw:px-5 tw:py-4 tw:flex tw:flex-col">
        <div class="tw:flex tw:flex-col tw:items-start tw:mb-1">
          <img :src="OfferIcon" alt="Offer Icon" class="tw:w-6 tw:h-10" />
          <p class="tw:text-xl tw:font-bold tw:text-gray-800">{{ $t('ri_nba_hotel_offers') }}</p>
        </div>
        <p class="tw:text-base tw:font-normal tw:text-gray-800 tw:mb-4 tw:flex-1">
          {{ $t('ri_nba_ho_subtext') }}
        </p>
        <div class="tw:border-t tw:border-gray-300 tw:pt-3">
          <router-link
            :to="{ name: 'hotel-offers' }"
            class="tw:text-blue-700 tw:text-base tw:font-bold tw:hover:underline"
          >
            {{ $t('ri_nba_ho_cta') }}
          </router-link>
        </div>
      </div>
    </div>

    <div
      class="tw:border tw:border-gray-300 tw:bg-gray-100 tw:rounded-lg tw:px-5 tw:py-4 tw:flex tw:items-start tw:gap-3 tw:mt-4"
    >
      <div>
        <p class="tw:text-gray-800 tw:font-bold">{{ $t('ri_nba_rates_header') }}</p>
        <p class="tw:text-gray-800 tw:text-sm">{{ $t('ri_nba_rates_subtext') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import CoinsIcon from '@/assets/img/rate-insights/coins-icon.svg'
import OfferIcon from '@/assets/img/rate-insights/offer-icon.svg'
</script>
